const getDefaultState = () => {
    return {
        totalBookCount: "0",
        webBaseInfo: {},
        webNavData: [],
    };
};
const state = getDefaultState();

const mutations = {
    RESET_STATE: (state) => {
        // Object.assign(state, getDefaultState());
    },
    SET_COUNT: (state, totalBookCount) => {
        // state.totalBookCount = totalBookCount;
    },
};

const actions = {
    // 获取图书总数
    getBooksCount({ commit, state }) {
        return new Promise((resolve, reject) => {
            // getBookCount().then((res) => {
            //     if (res.code === 1) {
            //         commit("SET_COUNT", '');
            //         resolve(1);
            //     }
            // });
        });
    },

};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};